module.exports = __webpack_public_path__ + "img/pr-1.93146eba.png";